import type { DashboardRealtimeMessage } from "../realtime/dashboardRealtimeTypes";

export function shouldTriggerDashboardDataRefresh(
  message: DashboardRealtimeMessage,
): boolean {
  return (
    !(
      message.type === "instance_activity" &&
      message.payload.activity_type === "channel_wake_claimed"
    ) &&
    message.type !== "provider_progress" &&
    message.type !== "repository_chat_snapshot" &&
    message.type !== "task_snapshot" &&
    message.type !== "task_callback"
  );
}
